module.exports = __webpack_public_path__ + "static/media/442px-Emblem_of_Vatican_City.53b6af6e.png";